import React from "react";

import { DeviceDetector } from "@utils";
import classNames from "classnames";

export function MuteButton(props: { muted: boolean; toggleMute: () => void }) {
	const { muted, toggleMute } = props;

	const muteBtnClasses = classNames("widget__btn btn btn--square", {
		"btn--square--xsml": !DeviceDetector.isMobileTheme,
		"btn--square--sml btn--secondary widget--ls__btn":
			DeviceDetector.isMobileTheme,
	});

	const muteIconClass = classNames("widget__btn__icon u-icon", {
		"u-icon--tny": !DeviceDetector.isMobileTheme,
		"u-icon--sml": DeviceDetector.isMobileTheme,
		"u-icon--video-volume-off": muted,
		"u-icon--video-volume-on": !muted,
	});

	return (
		<button type="button" className={muteBtnClasses} onClick={toggleMute}>
			<i className={muteIconClass} />
		</button>
	);
}
